module.exports = __webpack_public_path__ + "static/media/27.07b09816.webp";